import { MemoizedSelector, createSelector } from '@ngrx/store';
import { OeeAppState } from '../oee.reducer';
import { INotificationFeedState } from './notification-feed.model';

export const selectNotificationOnlyShowUnread: MemoizedSelector<OeeAppState, boolean> = createSelector(
  (state: OeeAppState) => state.notificationFeed,
  (state: INotificationFeedState) => state.onlyShowUnread,
);
